import { useEffect, useRef, useState } from "react";
import { TextInput } from "@mantine/core";

/**
 * @param {import('@mantine/core').TextInputProps & {
 *   onThrottledChange?: (value: string) => void,
 *   delay?: number
 * }} props
 */
export default function ThrottledTextInput({
  value,
  onThrottledChange,
  delay = 600,
  ...props
}) {
  const [internalValue, setInternalValue] = useState(value || "");
  const timeoutRef = useRef(null);

  useEffect(() => {
    setInternalValue(value || "");
  }, [value]);

  const handleChange = (e) => {
    const val = e.currentTarget.value;

    // instant UI update
    setInternalValue(val);

    // throttle external update
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      onThrottledChange?.(val);
    }, delay);
  };

  return (
    <TextInput
      {...props}
      value={internalValue}
      onChange={handleChange}
    />
  );
}